import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  padding-bottom: 40px;
`
export const Content = styled.div`
  width: calc(80vw - 350px);
  left: 250px;
  height: 100vh;
  overflow-y: visible;
`
export const CompanyCard = styled.div`
  background: #ffffff;
  border: none;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 30px 40px 100px 40px;
`
export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
`
export const InformationCompany = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-self: center;
  width: 50%;
  align-items: center;
  gap: 50px;
`

interface ILabelDiv {
  alignItems?: string
  justifyContent?: string
  width?: string
  height?: string
  marginTop?: string
}

export const FormContainerItem = styled.div<ILabelDiv>`
  align-self: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: ${(props) => props.alignItems || 'center'};
  margin-top: ${(props) => props.marginTop || '0px'};
`
export const IconSvgProfile = styled.svg`
  color: #2d749c;
  fill: #2d749c;
  width: 24px;
  height: 24px;
`

export const LabelDiv = styled.div<ILabelDiv>`
  width: 38%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`

export const Label = styled.label`
  font-size: 14px;
  color: #1f2124;
  font-weight: 600;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
`

export const BluesiteTable = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
`
export const TableDivider = styled.hr`
  border: 1px solid #1f2124;
  width: 100%;
`
export const TableHeaders = styled.thead`
  margin-bottom: 30px;
  border-bottom: 1px solid #1f2124;
  padding: 0.3em;
  justify-content: space-between;
`
export const ActionsCell = styled.th`
  justify-content: flex-end;
  width: 25%;
`
export const TableBody = styled.tbody`
  border-top: 1px solid;
  padding-top: 30px;
  justify-content: space-between;
`
export const TableSelect = styled.select`
  width: 63px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: none;
  margin: 10px;
  padding: 10px;
`
export const OptionSelect = styled.option`
  padding: 10px;
`
export const UpdateLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e44646;
  font-weight: bold;
  cursor: pointer;
`

export const ActionIcon = styled.svg`
  fill: #e44646;
  clip-rule: evenodd;
  fill-rule: evenodd;
  stroke-miterlimit: 2;
  width: 24px;
  height: 24px;
  margin-right: 5px;
`

interface IRow {
  height?: string
  width?: string
  justifyContent?: string
  alignItems?: string
  gap?: string
  margin?: string
  padding?: string
  flexDirection?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'row'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'center'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || 'auto'};
  gap: ${(props) => props.gap || '0px'};
  margin: ${(props) => props.margin || '0px'};
  padding: ${(props) => props.padding || '0px'};
`
export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 240px));
  justify-content: center;
  width: 100%;
  gap: 16px;
  margin: 28px 0 40px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`
export const Card = styled.div`
  background: linear-gradient(135deg, #c6016b 0%, #2d749c 100%);
  border: 1px solid transparent;
  box-shadow: 0 10px 24px rgba(45, 116, 156, 0.18);
  border-radius: 14px;
  display: flex;
  align-items: stretch;
  min-height: 58px;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 30px rgba(45, 116, 156, 0.28);
  }
`

export const CardDescriptionSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 58px;
  padding: 12px 16px;
  text-align: center;
`

export const CardTitle = styled.span`
  color: #ffffff;
  font-family: 'Public Sans', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.3;
`

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f4f8ff;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
  padding: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`

export const Circle = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ErrorContainer = styled.div`
  margin-top: 10px;
  color: red;
  width: 100%;
`

export const TextError = styled.span`
  color: red;
  text-align: left !important;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f4f8ff;
  border-radius: 20px;
  padding: 30px 0 40px 30px;
  margin: 20px 0;
  gap: 60px;
`

export const InfoContainer = styled.div<{ addGap?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.addGap ? '50px' : '20px')};
  margin-top: ${(props) => (props.addGap ? '18px' : '0')};
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`

export const CompanySettingsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  padding: 0 30px 0 10px;
  align-items: start;

  ${CheckboxContainer} {
    min-width: 0;
    width: 100%;
    margin-bottom: 0;
  }

  @media (max-width: 1240px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
    padding-right: 10px;
  }
`

export const LastButtonsContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 60px;
  gap: 20px;
`

export const ButtonEdit = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 15px;
  font-weight: bold;
  align-items: center;
  gap: 5px;
  width: fit-content;
  min-height: 48px;
  padding: 0 22px;
  margin: 30px 0 30px auto;
  border-radius: 14px;
  background: linear-gradient(135deg, #c6016b 0%, #2d749c 100%);
  color: #ffffff;
  box-shadow: 0 12px 30px rgba(36, 93, 125, 0.18);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 16px 34px rgba(36, 93, 125, 0.22);
    filter: saturate(1.05);
  }
`
